import { Money } from '../model/money.types';

export const getMoneyAsString = (money: Money) => {
    switch (money.currency) {
        case 'EUR':
            return `€${'\u00A0'}${new Intl.NumberFormat('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(money.amount)}`;
        default:
            return money.amount;
    }
};

export const addUpCosts = (costs: Money[], startValue = 0): Money => ({
    currency: costs[0]?.currency || 'EUR',
    amount: costs.reduce(
        (accumulator, current) => accumulator + current.amount,
        startValue
    ),
});
